import { BoardOverlayType } from '~shared/enums';

/**
 * Lacquered boards (powder-coated or wet-painted) are pictured as a whole panel
 * on a plain backdrop, where every other board is pictured with a seamless crop
 * of its decor. Their picture therefore has to be fitted rather than cropped,
 * and their swatch is the paint colour itself rather than a decor sample.
 */
export function isLacqueredBoard(board?: { overlayType?: BoardOverlayType }): boolean {
	return board?.overlayType === BoardOverlayType.POWDER_COATING
		|| board?.overlayType === BoardOverlayType.WET_PAINT;
}
